module.exports = __webpack_public_path__ + "img/login-bg.0dec0c9b.svg";